import isOpen from './is-open';
import displayMode from './display-mode';

export default {
  isOpen,
  displayMode,
};
